import { render, staticRenderFns } from "./CreateItemModal.vue?vue&type=template&id=09497a8f&scoped=true"
import script from "./CreateItemModal.vue?vue&type=script&lang=ts"
export * from "./CreateItemModal.vue?vue&type=script&lang=ts"
import style0 from "./CreateItemModal.vue?vue&type=style&index=0&id=09497a8f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09497a8f",
  null
  
)

export default component.exports